import { ApiServiceV1 } from '@services';

export const ReplacementsApiService = {
  async getReplacements({ suffix }) {
    const { data } = await ApiServiceV1.get(`${suffix}/settings/replacements`);

    return data || [];
  },

  createReplacement({ suffix, data }) {
    return ApiServiceV1.post(`${suffix}/settings/replacements`, data);
  },

  updateReplacement({ suffix, id, data }) {
    return ApiServiceV1.put(`${suffix}/settings/replacements/${id}`, data);
  },

  changeReplacementState({ suffix, id, state: enabled }) {
    return ApiServiceV1.put(`${suffix}/settings/replacements/${id}/state`, { enabled });
  },

  removeReplacement({ suffix, id }) {
    return ApiServiceV1.delete(`${suffix}/settings/replacements/${id}`);
  },

  async getSubstrates({ suffix }) {
    const { data } = await ApiServiceV1.get(`${suffix}/substrate/list`);

    return data || [];
  },
};
